import React, {useState} from 'react'
import {
    Box,
    Typography,
    Card,
    Divider,
    Rating,
    Button,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    Stepper, Step, StepLabel
} from "@mui/material";
import useStyles from "../../../../assets/styles/ProgramRatingStyles";
import Logo from '../../../../assets/images/DQStarsRating_2STAR.png'
import {useHistory} from "react-router-dom";
import {APP_STATUS} from "../../../../utils/constants";
const CPCRatingContentReport = ({ data, actions, options }) => {
    const history = useHistory();
    const classes = useStyles();
    const [showReportDialog, setShowReportDialog] = useState(false);
    const { programInfo, programStatus, programStatusV3, programPaymentStatus,currentStatus,RATING_STEPS } = data;
    const { showPdfReportAction, signUpAction, downloadBadgeAction, accessAssessmentAction,goToDQCreatorAction } = actions;
    const { isGuestUser,programId } = options;
    const activeStep = RATING_STEPS.findIndex(step => step.status === currentStatus);

    const handleShowPdfReport = () => {
        showPdfReportAction();
    };
    const handleGoToDQCreator = () => {
        goToDQCreatorAction();
    };

    const handleAccessAssessment = (programId, programStatus) => {
        if (accessAssessmentAction) {
            accessAssessmentAction(programId, programStatus);
        }
    };

    return (
        <>
            <Box sx={{ backgroundColor:'#F4EEEE', padding:{sm:'0px !important', xs:'16px !important'}}}>
                {/*<Typography variant="h3" sx={{ textAlign: "center", marginBottom: 6, paddingTop: 4, marginTop:{xs:'55px', sm:'0px'} }} className={classes.title}>*/}
                {/*    CPC Stars Summary Report*/}
                {/*</Typography>*/}
                <Box sx={{ p: 3 }}>

                    <Stepper
                        activeStep={activeStep}
                        alternativeLabel
                        sx={{
                            '& .MuiStepLabel-root .Mui-completed': {
                                color: '#ff6468ff'
                            },
                            '& .MuiStepLabel-root .Mui-active': {
                                color: '#ff6468ff'
                            },
                            '& .MuiStepLabel-root .Mui-disabled': {
                                color: '#ff6468ff',
                                opacity: 0.5
                            },
                            '& .MuiStepConnector-root .MuiStepConnector-line': {
                                borderColor: '#ff6468ff',
                                borderTopWidth: '6px',
                                // marginTop: '-12px'
                            }
                        }}
                    >
                        {RATING_STEPS.map((step) => (
                            <Step key={step.label}>
                                <StepLabel
                                    StepIconProps={{
                                        sx: {
                                            '&.Mui-completed': {
                                                color: '#ff6468ff',
                                                fontSize: '1.7rem',
                                                '& .MuiStepIcon-text': {
                                                    display: 'none'
                                                }
                                            },
                                            '&.Mui-active': {
                                                color: '#ff6468ff',
                                                fontSize: '1.7rem',
                                                '& .MuiStepIcon-text': {
                                                    display: 'none'
                                                }
                                            },
                                            fontSize: '1.7rem',
                                            '& .MuiStepIcon-text': {
                                                display: 'none'
                                            }
                                        }
                                    }}
                                >
                                    {step.label}
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
                <Grid container sx={{display:'flex',justifyContent:'center',marginTop:6,}}>
                    <Grid item
                          xs={12}
                          sm={4}
                          sx={{display: "flex", flexDirection: "column",marginRight: {sm:'15px'}, padding: "0 30px",alignItems:'center',borderRadius:'15px', backgroundColor:'#FFFF',
                    }}>
                        <Typography variant="h6" sx={{ marginTop: 5 }} className={classes.ReportTitle}>Your DQ Stars Rating</Typography>
                        <Typography variant="h7" sx={{ marginTop: 0, fontWeight:'bold' }} >Digital Citizenship for Children</Typography>
                        <Box
                            component="img"
                            src={Logo}
                            alt="Logo"
                            sx={{ width: "180px",marginTop: 5, marginBottom: 5,  alignSelf: "center", }}
                        />
                        {/*<Box sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>*/}
                        {/*    <Rating*/}
                        {/*        value={2}*/}
                        {/*        max={3}*/}
                        {/*        readOnly*/}
                        {/*        icon={<span style={{ color: "#FFD700", fontSize: "80px" }}>★</span>}*/}
                        {/*        emptyIcon={<span style={{ color: "#E0E0E0", fontSize: "80px" }}>★</span>}*/}
                        {/*    />*/}
                        {/*</Box>*/}
                        <Typography variant="h5" gutterBottom sx={{fontWeight:'bold',marginBottom: 5,color:'#000000', textAlign:'center',padding: "0 25px",}}>
                            Congratulations on achieving <br/>
                            the DQ 2 Star Rating!
                        </Typography>
                        <Typography sx={{padding: "0 25px",color:'#000000',marginBottom: 5,}}>
                            Your program empower learners with intermediate digital citizenship skills that build confidence, promote well-being, and
                            encourage responsible online behavior. It aligns with at least two topics from the  Digital Citizenship for Children (DCC)
                            Framework, including Basic Cyber Security and Privacy Management, Cyber Safety Management, and Cyber Civility. They excel in
                            delivering practical skills with a focus on personal and online well-being, thereby adopting a holistic approach to digital citizenship.
                        </Typography>
                        {/*<Typography sx={{padding: "0 25px",fontStyle:'italic'}}>*/}
                        {/*    This rating showcases your alignment to CPC’s Cyber Citizenship Framework based on the IEEE DQ Global Standards (IEEE3527.1 <sup>TM</sup>).*/}
                        {/*</Typography>*/}
                        <Button
                            variant="contained"
                            className={classes.badgeButton}
                            onClick={() => {
                                if (isGuestUser) {
                                    signUpAction();
                                } else {
                                    downloadBadgeAction();
                                }
                            }}>
                            Download Badge
                        </Button>
                    </Grid>

                    {/* Right Section */}
                    <Grid item xs={12}
                          sm={7}
                          sx={{display: "flex", flexDirection: "column", alignItems:'center',marginTop:{sm:'0px',xs:'25px'}, gap: 3,backgroundColor:'#FFFF',borderRadius:'15px', paddingBottom:'30px'
                    }}>
                        <Typography variant="h4" style={{fontSize: '35px !important', fontWeight:'bold', textAlign: 'center',}} sx={{ marginTop: '55px' }}>About Your Program</Typography>
                        <Box sx={{ display: "flex",flexDirection: { xs: "column", sm: "row" }, gap: 2, width:'90%' }}>
                            {programInfo.map((item, index) => (
                                <Card
                                    key={index}
                                    sx={{
                                        padding: 2,
                                        flex: 1,
                                        backgroundColor: "#F5F5F5",
                                        textAlign: "center",
                                    }}
                                >
                                    <Typography variant="subtitle1" style={{fontWeight:'bold', color:'#ED6628', marginBottom:'10px'}}>{item.title}</Typography>
                                    <Typography variant="body2" style={{marginTop:'auto'}}>{item.value}</Typography>
                                </Card>
                            ))}
                        </Box>
                       <Grid item  sx={{display: "flex", flexDirection: "column",color:'#000000', alignItems:'center', paddingLeft:'15px', }}>
                           <Grid>
                                   <Typography
                                       variant="h6"
                                       sx={{ fontWeight: 'bold', marginBottom: '8px',padding:'0 15px' , width:'100%' }}
                                   >
                                       A. Evaluation Results: DQ Conformity Test for Digital Citizenship
                                   </Typography>
                                   <Typography
                                       variant="body1"
                                       sx={{ marginBottom: '16px',padding:'0 15px' }}
                                   >
                                       Your program demonstrates alignment with <span style={{color:'#ea516b', fontWeight:'bold'}}>2 out of 3 core Digital Citizenship Topics</span> in the Digital
                                       Citizenship for Children (DCC) Framework:
                                   </Typography>
                               <Box sx={{display:'flex', flexDirection:{sm:'row', xs:'column'},paddingBottom:'15px', alignItems:'end'}}>
                                   <Box sx={{display:'flex', flexDirection:'column', alignItems:'left'}}>
                                       <Typography  component="li" variant="h6" sx={{ marginTop: 3, padding:{sm:'0px 0px 0px 10px', xs:'10px 0px 10px 10px'}, fontWeight:'bold', }} style={{
                                            textAlign:'left',}}>
                                            Aligned Topics
                                        </Typography>
                                        <Box component="ul" sx={{padding:{sm:'10px 0px 10px 60px', xs:'10px 0px 10px 10px'}}} style={{textAlign:'left',width:'85%'}}>
                                            <Typography component="li" style={{fontWeight:'bold', marginLeft:'20px',}}>
                                                Basic Cybersecurity & Privacy Management
                                            </Typography>
                                            <Typography component="li" style={{fontWeight:'bold', marginLeft:'20px',}}>
                                                Cyber Civility
                                            </Typography>
                                        </Box>
                                       <Typography component="li" sx={{ padding:{sm:'0px 0px 10px 10px',}}}>
                                           It also aligns with <span style={{color:'#ea516b', fontWeight:'bold'}}>12 out of 15 key digital citizenship competencies,</span>{' '}
                                           highlighting a foundation in promoting digital literacy and readiness.
                                       </Typography>
                                   </Box>

                                  <Box sx={{marginRight:3, width:{sm:'30%', xs:'60%'}}}>
                                   <Button className={classes.badgeButton} style={{width:'205px', lineHeight:'18px'}} variant="contained" color="primary" sx={{ marginLeft: '16px' }}
                                       // onClick={() => isGuestUser ? signUpAction() : handleShowPdfReport()}>
                                           onClick={() => {
                                               if (isGuestUser) {
                                                   signUpAction();
                                               } else {
                                                   setShowReportDialog(true);
                                               }
                                           }}
                                   >
                                       VIEW FULL DQ STARS REPORT
                                       {/*{programPaymentStatus < APP_STATUS.COMPLETED ? (*/}
                                       {/*    <>*/}
                                       {/*        PURCHASE <br /> Full Report*/}
                                       {/*    </>*/}
                                       {/*) : (*/}
                                       {/*    <>*/}
                                       {/*        SHOW <br /> Full Report*/}
                                       {/*    </>*/}
                                       {/*)}*/}
                                   </Button>
                               </Box>
                               </Box>
                               <Divider
                                   sx={{
                                       marginY: 2,
                                       borderColor: 'rgba(0, 0, 0, 0.1)',
                                       borderWidth: '1px',
                                       borderStyle: 'solid'
                                   }}
                               />
                      </Grid>

                    <Grid>
                           <Typography
                               variant="h6"
                               sx={{ fontWeight: 'bold', marginBottom: '8px',textAlign:'left',padding:'0 15px' , width:'100%' }}
                           >
                               B. Measure Your Impact
                           </Typography>
                           <Typography
                               variant="body1"
                               sx={{ marginBottom: '16px', padding:'0 15px' }}
                           >
                               Implement a tailored impact assessment based on your <strong>DQ Stars Alignment</strong> to seamlessly connect with
                               the <strong>CPC Index—</strong>{' '}the global benchmark for digital citizenship and child online safety.
                           </Typography>
                        <Typography variant="body1" sx={{padding:{sm:'10px 0px 10px 15px', xs:'10px 0px 10px 10px'}}} style={{textAlign:'left',}}>
                            This empowers your program to:
                        </Typography>
                          <Box sx={{display:'flex', flexDirection:{sm:'row', xs:'column'}, alignItems:'center'}}>
                            <Box component="ul" sx={{padding:{sm:'10px 0px 10px 60px', xs:'10px 0px 10px 10px'}}} style={{width:'85%', textAlign:'left'}}>
                                <Typography component="li">
                                    <strong>Demonstrate measurable impact </strong> to engage clients, secure funding,
                                        and strengthen government partnerships
                                </Typography>
                                <Typography component="li">
                                    <strong>Align with leading global initiatives </strong> {' '} like the <strong>Global Cybersecurity
                                    Forum</strong> and the <strong>UN’s Pact for the Future</strong>
                                </Typography>
                            </Box>
                        <Box sx={{marginRight:3,  width:{sm:'30%', xs:'60%'},}}>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.badgeButton}
                                style={{width:'205px', lineHeight:'18px'}}
                                sx={{ marginLeft: '16px' }}
                                onClick={() => handleAccessAssessment(programId, programStatus)}
                            >
                                {
                                    programStatus >= APP_STATUS.ASSESSMENTS_READY ? 'Access Assessment' :
                                        programStatus < APP_STATUS.ASSESSMENTS_READY ? 'Add Impact Assessment' : ''
                                }
                            </Button>

                        </Box>
                      </Box>
                      <Divider
                        sx={{marginY: 2, borderColor: 'rgba(0, 0, 0, 0.1)', borderWidth: '1px', borderStyle: 'solid'}}/>
                    </Grid>

                    <Grid>
                           <Typography
                               variant="h6"
                               sx={{ fontWeight: 'bold', marginBottom: '8px',padding:'0 15px' , width:'100%' }}
                           >
                               C. Potential Enhancements for Program Content
                           </Typography>
                           <Typography
                               variant="body1"
                               sx={{ marginBottom: '16px',padding:'0 15px' }}
                           >
                               With targeted improvements, your program can align with additional digital citizenship topics—bringing it
                               closer to a higher DQ Stars Rating and increasing its educational effectiveness and global credibility.
                           </Typography>
                        {/*       <Typography variant="h6" sx={{padding:{sm:'10px 0px 10px 50px', xs:'10px 0px 10px 10px'}}}  style={{*/}
                        {/*    fontWeight:'bold',*/}
                        {/*    textAlign:'left'}}>Cyber Citizenship Competencies Your Program Could Enhance</Typography>*/}
                        <Box sx={{display:'flex', flexDirection:{sm:'row', xs:'column'}, alignItems:'center', justifyContent:'flex-end'}}>
                        {/*<Box sx={{padding:{sm:'10px 0px 10px 60px', xs:'10px 0px 10px 10px'}}}*/}
                        {/*        style={{ width: '85%', fontWeight: 'bold', listStyleType: 'disc',}}*/}
                        {/*        component="ul"*/}
                        {/*    >*/}
                        {/*        <Typography component="li" style={{ fontWeight: 'bold' }}>*/}
                        {/*            <strong style={{ color: "#ED6628" }}>34% Aligned</strong> - Managing Cyberbullying*/}
                        {/*        </Typography>*/}
                        {/*        <Typography component="li" style={{ fontWeight: 'bold' }}>*/}
                        {/*            <strong style={{ color: "#ED6628" }}>27% Aligned</strong> - Managing Contact Risks*/}
                        {/*        </Typography>*/}
                        {/*        <Typography component="li" style={{ fontWeight: 'bold', color: '#ea516b', textDecoration: 'underline' }}>*/}
                        {/*            Get Full Report to See Other Competencies Your Program Can Easily Enhance*/}
                        {/*        </Typography>*/}
                        {/*    </Box>*/}
                        {/*    <Box sx={{width:{sm:'28%', xs:'60%'},}}>*/}
                                <Button className={classes.badgeButton} style={{width:'205px',marginRight:'27px', lineHeight:'18px'}} variant="contained" color="primary" sx={{ marginLeft: '16px' }}
                                        onClick={() => isGuestUser ? signUpAction() : handleGoToDQCreator()}>
                                    ENHANCE PROGRAM CONTENT
                                </Button>
                            {/*</Box>*/}
                        </Box>
                    </Grid>
                 </Grid>
                </Grid>
                </Grid>
            </Box>

            {/* Popup Dialog */}
            <Dialog maxWidth="md" fullWidth PaperProps={{style: {
                    width: '30%',
                    height: '33%',
                    maxWidth: 'none',
                    borderRadius:'20px',
                    paddingTop:'20px',
                },}} open={showReportDialog} onClose={() => setShowReportDialog(false)}>
                <DialogTitle style={{textAlign:'center'}}>Here’s your full DQ Stars Report. </DialogTitle>
                <DialogContent style={{textAlign:'center', fontWeight:'normal'}}>
                    <Typography variant="h7" style={{textAlign:'center', fontSize:'18px'}}>
                        After reviewing and if you would like to add an impact assessment click the <strong>“Add Impact Assessment”</strong> {' '}button at the top of the screen.
                    </Typography>
                </DialogContent>
                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '15px', marginBottom: '20px' }}>
                    <Button
                        variant="contained"
                        className={classes.dialogButton}
                        onClick={() => {
                            setShowReportDialog(false);
                            handleShowPdfReport();
                        }}
                    >
                        OK
                    </Button>
                </Box>
            </Dialog>
        </>
    );
}

export default CPCRatingContentReport;
